export default "/_next/static/images/service-wellness-desktop-2x-611dc47a5a62e45157922fef9c7bbbc0.jpg";